import React from 'react'

const SingleShow = () => {
  return (
    <div>SingleShow</div>
  )
}

export default SingleShow